"use strict";
import { toGqlSafetyLevel } from "components/TokenSelector/utils";
import { getNativeAddress } from "constants/uniswapAddresses";
import { toSupportedChainId } from "features/chains/utils";
import { buildCurrency, getCurrencySafetyInfo } from "features/dataApi/utils";
import { NATIVE_ADDRESS_FOR_TRADING_API } from "features/transactions/swap/utils/tradingApi";
import { currencyId } from "utils/uniswapCurrencyId";
export function tradingApiSwappableTokenToCurrencyInfo(token) {
  const isNative = token.address === NATIVE_ADDRESS_FOR_TRADING_API;
  const supportedChainId = toSupportedChainId(token.chainId);
  if (!supportedChainId) {
    return void 0;
  }
  const currency = buildCurrency({
    chainId: supportedChainId,
    address: isNative ? getNativeAddress(supportedChainId) : token.address,
    decimals: token.decimals,
    symbol: token.symbol,
    name: token.name
  });
  if (!currency) {
    return void 0;
  }
  const safetyLevel = toGqlSafetyLevel(token.project.safetyLevel);
  const currencyInfo = {
    currency,
    currencyId: currencyId(currency),
    logoUrl: token.project.logo?.url,
    isSpam: token.project.isSpam,
    safetyInfo: getCurrencySafetyInfo(safetyLevel ?? void 0)
  };
  return currencyInfo;
}
